// SPDX-License-Identifier: GPL-3.0-or-later
// Code-built ball. The upstream ball loads a JSON mesh. This one is a sphere.

import { type BufferGeometry, SphereGeometry } from "three";

/** Build a ball geometry. The origin is the centre of the ball. */
export function generateBall(radius: number): BufferGeometry {
  const geometry = new SphereGeometry(radius, 32, 20);
  geometry.name = "ball";
  return geometry;
}
